import { IRootState } from '../../../../store'
import { IBloodProductAdministrationState } from '../store/bloodProductAdministration.types'

export const getBloodProductAdministrationSelector = (state: IRootState): IBloodProductAdministrationState =>
  state.bloodProductAdministration
